import { render, staticRenderFns } from "./OStarRating.vue?vue&type=template&id=6913ecd8&"
import script from "./OStarRating.vue?vue&type=script&lang=js&"
export * from "./OStarRating.vue?vue&type=script&lang=js&"
import style0 from "./OStarRating.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports